import { useCallback, useEffect, useState } from "react";

function readHash(): string {
  const raw = window.location.hash || "#/";
  return raw.startsWith("#") ? raw : `#${raw}`;
}

export function useHashRoute(): {
  hash: string;
  path: string;
  navigate: (next: string) => void;
} {
  const [hash, setHash] = useState<string>(() => readHash());

  useEffect(() => {
    const onChange = () => setHash(readHash());
    window.addEventListener("hashchange", onChange);
    return () => window.removeEventListener("hashchange", onChange);
  }, []);

  const navigate = useCallback((next: string) => {
    const normalized = next.startsWith("#") ? next : `#${next}`;
    if (normalized === window.location.hash) return;
    window.location.hash = normalized;
  }, []);

  const path = hash.slice(1) || "/";
  return { hash, path, navigate };
}
